module.exports = __webpack_public_path__ + "static/media/play-store-es.97f221b5.svg";